<template>
    <div class="user-menu" @mouseenter="dropDown(), arrowImg.now = arrowImg.hover" @mouseleave="dropUp(), arrowImg.now = arrowImg.default">
        <span class="user-title">
            <div class="shot">
                <img v-if="userShot" :src="userShot" alt="">
                <img v-else src="@/assets/img/shot.svg" alt="">    
            </div>
            <img class="arrow" :src="arrowImg.now" alt="">
        </span>
        <transition  name="fade"> 
            <ul v-show="show" @click="dropUp">
                <router-link  :to="{ path: '/landlord/housestatus/member#認證房東'}">
                    <li>認證房東</li>
                </router-link>
                <router-link  :to="{ path: '/landlord/housestatus/member#個資編輯'}">
                    <li>個資編輯</li>
                </router-link>
                <router-link  :to="{ path: '/landlord/housestatus/member#飛豬錢包'}">
                    <li>飛豬錢包</li>
                </router-link>
                <router-link  :to="{ path: '/landlord/housestatus/member#委託付款紀錄'}">
                    <li>委託付款紀錄</li>
                </router-link>
                <a @click="$analytics.logEvent('操作指南', { screen_name: '操作指南'})" href="https://flypig-public.s3-ap-southeast-1.amazonaws.com/doc/manual.pdf" target="_blank" rel="noopener noreferrer">
                    <li>操作指南</li>
                </a>
                <router-link  :to="{ path: '/landlord/housestatus/member#共同設定'}">
                    <li>共同設定</li>
                </router-link>
                <!-- <router-link :to="{ path: '/landlord/housestatus/member#操作日誌'}">
                    <li>操作日誌</li>
                </router-link> -->
                <li class="logout" @click="logout(), $analytics.logEvent('使用者選單_登出', { screen_name: '使用者選單_登出'})">登出</li>
            </ul>
        </transition> 
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: 'UserMenu',
    data () {
        return {
            show: 0,
            arrowImg: {
                now: require('../../assets/img/icon/arrow_down_gray.svg'),
                default: require('../../assets/img/icon/arrow_down_gray.svg'),
                hover: require('../../assets/img/icon/arrow_up_black.svg')
            }
        }
    },
    methods: {
        dropDown: function () {
            this.show = 1;
        },
        dropUp: function () {
            this.show = 0;
        },
        logout: function () {
            this.$store.dispatch('logout')
        }
    },
    computed: {
        ...mapGetters({
            userShot: 'GET_VERIFIED_USER_SHOT'
        })
    }
}
</script>
<style scoped lang="scss">
    .user-menu{
        // width: 44px;
        // height: 44px;
        .user-title{
            display: flex;
            .shot{
                width: 44px;
                height: 44px; 
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                margin-right: 3px;
                box-shadow: 0px 2px 4px rgba(165, 166, 187, 0.2);
                overflow: hidden;
                img{
                    width: 44px;
                }
            }
        }
        ul{
            position: absolute;
            right: -31px;
            width: 187px;
            padding: 4px 0;
            border-radius: 4px;
            // background: #000;
            background: #f0f0f0;
            top: 47px;
            border: solid 1px #eeeeee;
            box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
            z-index: 9999;
            li{
                position: relative;
                display: flex;
                align-items: center;
                padding: 12px 24px;
                cursor: pointer;
                a{
                    display: flex;
                    align-items: center;
                }
            }
            li:hover{
                background: #fff;
            }
            li.logout{
                color: #ff9275;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/UserMenu.vue